import {lazy} from "react";

const SearchAccessProfile = lazy(() => import("./SearchBusinessRoles"));
const EditBusinessRoles = lazy(() => import("./EditBusinessRoles"));

const businessRolesRoutes = [
    {
        path: "/business-role",
        element: <SearchAccessProfile/>,
    },
    {
        path: "/business-role/new",
        element: <EditBusinessRoles/>,
    },
    {
        path: "/business-role/:id",
        element: <EditBusinessRoles/>,
    },
];

export default businessRolesRoutes;